import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    q: "Il lavaggio senza acqua graffia la carrozzeria?",
    a: "No. La nostra formula nanotech contiene lubrificanti e agenti incapsulanti che sollevano lo sporco dalla superficie prima del contatto con il panno in microfibra. Utilizziamo inoltre tecnica di passaggio a due panni per massima sicurezza.",
  },
  {
    q: "Quanto dura l'effetto protettivo?",
    a: "Il sigillante nanotech applicato durante il lavaggio offre un effetto idrorepellente e una protezione dagli agenti atmosferici che varia in base alle condizioni di utilizzo, generalmente da 2 a 6 settimane.",
  },
  {
    q: "Dove operate? Venite anche fuori Rieti?",
    a: "Operiamo principalmente a Rieti e provincia con il nostro studio mobile in Via Curio Dentato, 9. Per zone limitrofe e servizi a domicilio contattaci: valutiamo caso per caso.",
  },
  {
    q: "Quanto costa un lavaggio completo?",
    a: "Il prezzo dipende dal tipo di veicolo (auto, SUV, furgone, camper) e dal pacchetto scelto. Richiedi un preventivo dal form qui sotto o tramite WhatsApp: ti rispondiamo in breve tempo.",
  },
  {
    q: "È davvero ecologico?",
    a: "Sì. I prodotti sono biodegradabili, zero scarichi in suolo o falde acquifere e ogni lavaggio risparmia fino a 150 litri d'acqua rispetto a un autolavaggio tradizionale.",
  },
  {
    q: "Come posso pagare?",
    a: "Accettiamo pagamenti in contanti, carta e metodi digitali (bancomat, bonifico). Per servizi ricorrenti offriamo formule dedicate.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-px bg-nexa-blue" />
            <span className="overline">FAQ</span>
          </div>
          <div className="heading text-3xl md:text-5xl text-white leading-tight">
            Domande frequenti.
          </div>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="card-surface border-0 px-6 data-[state=open]:border-nexa-blue/40"
            >
              <AccordionTrigger className="heading text-left text-white uppercase tracking-wide text-sm md:text-base hover:text-nexa-blue hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-nexa-muted text-sm md:text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
